import { AuditActionTypes } from './audit.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    newAuditSuccess: null,
    newAuditError: null,
    newAuditReqStatus: '',
    auditListSuccess: null,
    auditListError: null,
    auditDetailSuccess: null,
    auditDetailError: null,
    assignAuditSuccess: null,
    assignAuditError: null,
    assignAuditReqStatus: '',
    updateAuditStatusSuccess: null,
    updateAuditStatusError: null,
    updateAuditStatusReqStatus: '',
    auditAddLogSuccess: null,
    auditAddLogError: null,
    auditAddLogReqStatus: '',
    auditUpdateLogStatusSuccess: null,
    auditUpdateLogStatusError: null,
    auditUpdateLogStatusReqStatus: '',
    auditAddLogCommentSuccess: null,
    auditAddLogCommentError: null,
    auditAddLogCommentReqStatus: ''
}

const auditReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AuditActionTypes.NEW_AUDIT_REQUEST_SUCCESS:
            return {
                ...state,
                newAuditSuccess: action.payload,
                newAuditError: null,
                newAuditReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AuditActionTypes.NEW_AUDIT_REQUEST_ERROR:
            return {
                ...state,
                newAuditSuccess: null,
                newAuditError: action.payload,
                newAuditReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AuditActionTypes.NEW_AUDIT_REQUEST_STATUS:
            return {
                ...state,
                newAuditReqStatus: ''
            }
        case AuditActionTypes.AUDIT_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                auditListSuccess: action.payload,
                auditListError: null
            }
        case AuditActionTypes.AUDIT_LIST_REQUEST_ERROR:
            return {
                ...state,
                auditListSuccess: null,
                auditListError: action.payload
            }
        case AuditActionTypes.AUDIT_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                auditDetailSuccess: action.payload,
                auditDetailError: null
            }
        case AuditActionTypes.AUDIT_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                auditDetailSuccess: null,
                auditDetailError: action.payload
            }
        case AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST_SUCCESS:
            return {
                ...state,
                assignAuditSuccess: action.payload,
                assignAuditError: null,
                assignAuditReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST_ERROR:
            return {
                ...state,
                assignAuditSuccess: null,
                assignAuditError: action.payload,
                assignAuditReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AuditActionTypes.AUDIT_ASSIGN_USER_REQUEST_STATUS:
            return {
                ...state,
                assignAuditReqStatus: ''
            }
        case AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                updateAuditStatusSuccess: action.payload,
                updateAuditStatusError: null,
                updateAuditStatusReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST_ERROR:
            return {
                ...state,
                updateAuditStatusSuccess: null,
                updateAuditStatusError: action.payload,
                updateAuditStatusReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AuditActionTypes.AUDIT_UPDATE_STATUS_REQUEST_STATUS:
            return {
                ...state,
                updateAuditStatusReqStatus: ''
            }
        case AuditActionTypes.AUDIT_ADD_LOG_REQUEST_SUCCESS:
            return {
                ...state,
                auditAddLogSuccess: action.payload,
                auditAddLogError: null,
                auditAddLogReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AuditActionTypes.AUDIT_ADD_LOG_REQUEST_ERROR:
            return {
                ...state,
                auditAddLogSuccess: null,
                auditAddLogError: action.payload,
                auditAddLogReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AuditActionTypes.AUDIT_ADD_LOG_REQUEST_STATUS:
            return {
                ...state,
                auditAddLogReqStatus: ''
            }
        case AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                auditUpdateLogStatusSuccess: action.payload,
                auditUpdateLogStatusError: null,
                auditUpdateLogStatusReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST_ERROR:
            return {
                ...state,
                auditUpdateLogStatusSuccess: null,
                auditUpdateLogStatusError: action.payload,
                auditUpdateLogStatusReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AuditActionTypes.AUDIT_UPDATE_LOG_STATUS_REQUEST_STATUS:
            return {
                ...state,
                auditUpdateLogStatusReqStatus: ''
            }
        case AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST_SUCCESS:
            return {
                ...state,
                auditAddLogCommentSuccess: action.payload,
                auditAddLogCommentError: null,
                auditAddLogCommentReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST_ERROR:
            return {
                ...state,
                auditAddLogCommentSuccess: null,
                auditAddLogCommentError: action.payload,
                auditAddLogCommentReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AuditActionTypes.AUDIT_ADD_LOG_COMMENT_REQUEST_STATUS:
            return {
                ...state,
                auditAddLogCommentReqStatus: ''
            }
        case AuditActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default auditReducer